module.exports = __webpack_public_path__ + "img/electronic_reserved_selected.e92ddd8b.svg";